import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./page/home";
import Traceability from "./page/traceability/SearchTraceability";
import TraceabilityResult from "./page/traceability/TraceabilityId";
import Login from "./page/login";
import Dashboard from "./page/dashboard";
import PerusahaanAddHarga from "./page/perusahaan/PerusahaanAddHarga";
import RencanaTanam from "./page/RencanaTanam";
import AddRencanaTanam from "./page/petani/PetaniAddRencanaTanam";
import DetailTanamMasuk from "./component/DetailRencanaTanamMasuk";
import DetailTanamAktifPage from "./component/DetailRencanaTanamAktif";
import DetailHistoryTanam from "./component/DetailHistoryTanam";
import FormEditRencanaTanam from "./component/EditRencanaTanam";
import OrderProduct from "./page/Order";
import DetailOrderAktif from "./component/DetailOrderAktif";
import DetailHistoryOrder from "./component/DetailHistoryOrder";
import LogistikApprove from "./page/logistik/LogistikApproveOrder";
import UpdateOrder from "./page/petani/UpdateOrderPetani";
import PabrikTransaksi from "./page/pabrik/PabrikTransaksi";
import LogistikTransaksi from "./page/logistik/LogistikTransaksi";
import PerusahaanTransaksi from "./page/perusahaan/PerusahaanTransaksi";
import Users from "./page/admin/users";
import AddUser from "./page/admin/AddUser.jsx";
import EditUser from "./page/admin/EditUser.jsx";
import EditProfile from "./page/EditProfile";
import PerusahaanProfile from "./page/perusahaan/PerusahaanProfile";
import PerusahaanProfileEdit from "./page/perusahaan/PerusahaanProfileEdit.jsx";
import PetaniLahan from "./page/petani/PetaniLahan";
import PetaniAddLahan from "./page/petani/PetaniAddLahan";
import PetaniProfile from "./page/petani/PetaniProfile";
import PetaniProfileEdit from "./page/petani/PetaniProfileEdit.jsx";
import PabrikList from "./page/pabrik/PabrikDasar";
import PabrikAddList from "./page/pabrik/PabrikAddDasar";
import PabrikEditList from "./page/pabrik/PabrikEditDasar";
import PabrikProfile from "./page/pabrik/PabrikProfile";
import PabrikProduksi from "./page/pabrik/PabrikHarian";
import PabrikAddProduksi from "./page/pabrik/PabrikAddHarian";
import LogistikList from "./page/logistik/LogistikDasar";
import LogistikListAdd from "./page/logistik/LogistikAddDasar";
import LogistikProfile from "./page/logistik/logistik-profile";
import LogistikProfileEdit from "./page/logistik/LogistikProfileEdit.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import PabrikProfileEdit from "./page/pabrik/PabrikProfileEdit.jsx";

function App() {
  return (
    <div className="Cassava Super">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />

          {/*traceability*/}
          <Route path="/traceability" element={<Traceability />} />
          <Route path="/traceability/:id" element={<TraceabilityResult />} />

          {/*dashboard*/}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/update-harga" element={<PerusahaanAddHarga />} />

          {/*rencana tanam*/}
          <Route path="/rencanatanam" element={<RencanaTanam />} />
          <Route path="/rencanatanam/add" element={<AddRencanaTanam />} />
          <Route path="/rencanatanammasuk/:id" element={<DetailTanamMasuk />} />
          <Route path="/rencanatanam/:id" element={<DetailTanamAktifPage />} />
          <Route
            path="/rencanatanam/edit/:id"
            element={<FormEditRencanaTanam />}
          />
          <Route path="/historytanam/:id" element={<DetailHistoryTanam />} />

          {/*order*/}
          <Route path="/logistik-approve" element={<LogistikApprove />} />
          <Route path="/order" element={<OrderProduct />} />
          <Route path="/historyorder/:id" element={<DetailHistoryOrder />} />
          <Route path="/products/detail/:id" element={<DetailOrderAktif />} />
          <Route
            path="/logistik/transaksi/:id"
            element={<LogistikTransaksi />}
          />
          <Route path="/pabrik/transaksi/:id" element={<PabrikTransaksi />} />
          <Route path="/products/update/:id" element={<UpdateOrder />} />
          <Route
            path="/products/selesai/:id"
            element={<PerusahaanTransaksi />}
          />

          {/*admin*/}
          <Route path="/users" element={<Users />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/edit/:id" element={<EditUser />} />

          {/*perusahaan*/}
          <Route path="/profile-perusahaan" element={<PerusahaanProfile />} />
          <Route
            path="/profile-perusahaan/edit/:id"
            element={<PerusahaanProfileEdit />}
          />
          <Route path="/profile/edit/:id" element={<EditProfile />} />

          {/*petani-dasar*/}
          <Route path="/datalahan" element={<PetaniLahan />} />

          <Route path="/datalahan/add" element={<PetaniAddLahan />} />
          <Route path="/profile-petani" element={<PetaniProfile />} />
          <Route
            path="/profile-petani/edit/:id"
            element={<PetaniProfileEdit />}
          />

          {/*pabrik-dasar*/}
          <Route path="/data-pabrik" element={<PabrikList />} />
          <Route path="/data-pabrik/add" element={<PabrikAddList />} />
          <Route path="/data-pabrik/edit/:id" element={<PabrikEditList />} />
          <Route path="/profile-pabrik" element={<PabrikProfile />} />
          <Route
            path="/profile-pabrik/edit/:id"
            element={<PabrikProfileEdit />}
          />
          <Route path="/produksi" element={<PabrikProduksi />} />
          <Route path="/produksi/add" element={<PabrikAddProduksi />} />

          {/*logistik-dasar*/}
          <Route path="/data-logistik" element={<LogistikList />} />
          <Route path="/data-logistik/add" element={<LogistikListAdd />} />
          <Route path="/profile-logistik" element={<LogistikProfile />} />
          <Route
            path="/profile-logistik/edit/:id"
            element={<LogistikProfileEdit />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
